import "@fontsource-variable/roboto";
import "@fontsource-variable/inter";
import kufi from "@fontsource-variable/noto-kufi-arabic/files/noto-kufi-arabic-arabic-wght-normal.woff2?url";
import alexandria from "@fontsource-variable/alexandria/files/alexandria-arabic-wght-normal.woff2?url";

/**
 * Typefaces from the UAE Design System 3.0: Roboto for English text and Inter for English headings; Noto Kufi Arabic for Arabic text
 * and Alexandria for Arabic headings. The Arabic faces cover the Arabic block only, so Latin words inside Arabic text fall through to
 * Roboto (Inter in headings), and they are scaled so that an alef stands as tall as a Latin capital at the same font size: one type
 * scale, the two scripts at the same visual size. Noto Kufi's own line box (1.9 em) is narrowed to 1.5 em so that mixed lines keep their height.
 */
const ARABIC = "U+0600-06FF,U+0750-077F,U+0870-088E,U+0890-0891,U+0897-08E1,U+08E3-08FF,U+200C-200E,U+2010-2011,U+204F,U+2E41,U+FB50-FDFF,U+FE70-FE74,U+FE76-FEFC";

const css = `
@font-face {
  font-family: "PMO Arabic";
  src: url("${kufi}") format("woff2-variations");
  font-weight: 100 900;
  font-style: normal;
  font-display: swap;
  unicode-range: ${ARABIC};
  size-adjust: 94%;
  ascent-override: 104%;
  descent-override: 46%;
  line-gap-override: 0%;
}
@font-face {
  font-family: "PMO Arabic Heading";
  src: url("${alexandria}") format("woff2-variations");
  font-weight: 100 900;
  font-style: normal;
  font-display: swap;
  unicode-range: ${ARABIC};
  size-adjust: 88%;
}
`;

if (typeof document !== "undefined" && !document.querySelector("style[data-pmo-fonts]")) {
  const style = document.createElement("style");
  style.dataset.pmoFonts = "";
  style.textContent = css;
  document.head.appendChild(style);
}
